import { Injectable } from '@angular/core';
import { IAdapter } from '@drl/core/api/adapters/i-adapter';
import { User } from '@drl/core/auth/models/user.model';
import { UserStatus, userStatusTypesMap } from '@drl/core/enums/user-status.enum';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { genderMap } from '../models/gender.enum';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class CurrentUserAdapter implements IAdapter<User> {
  constructor(
    protected readonly translateSvc: IpsTranslateService,) { }

  adaptToModel(resp: any,isResEncrpyted?:boolean): User {
    if(isResEncrpyted) {
      resp = this.decrypt(
        resp.data,
        "eEqOKvwwnb7NDDRa",
        'AES-256-CBC',
        'yBLYND4axAehA7iKSrhLVUFmogjK7irz',
      );
    }
    
    const user: User = new User();
    const neutralIconPath = './assets/neutral-icon.svg';
    if (resp) {
      user.id = resp.id;
      user.firstName = resp.firstName;
      user.middleName = resp.middleName;
      user.lastName = resp.lastName;
      user.username = resp.username;
      user.email = resp.email;
      user.phone = resp.phone;
      user.roleId = resp.roleId;
      user.role = resp.role;
      user.permissions = resp.permissions;
      user.lastLogin = resp.lastLogin;
      user.status =
        resp.status &&
        userStatusTypesMap(this.translateSvc.translate)[parseInt(resp.status)];
      user.externalId = resp.externalId;
      user.gender =
        resp.gender &&
        genderMap(this.translateSvc.translate)[resp.gender.trim()];
      user.designation = resp.designation;
      user.photo = resp.photoUrl || neutralIconPath;
      user.pubnubToken = resp.pubnubToken;
      user.passwordExpiryTime = resp.passwordExpiryTime;
      user.bio = resp.bio;
      user.lang = resp.lang;
      user.experience = resp.experience;
      user.qualification = resp.qualification;
      user.lastOtp = resp.lastOtp;
      user.lastOtpDate = resp.lastOtpDate;
      user.isSelfOnb = resp.isSelfOnb;
      user.isAgeEntered = resp.isAgeEntered;
      user.isMinor = resp.isMinor;
      user.relation = resp.relation;
      user.relationLc = resp.relationLc;
      user.location = resp.location;
      user.deactivatedOn = resp.deactivatedOn;
      user.deactivatedReason = resp.deactivatedReason;
      user.deactivatedReasonLc = resp.deactivatedReasonLc;
      user.contigoId = resp.contigoId;
    }
    return user;
  }
  adaptFromModel(data: User): any {
    const dataToSend = Object.assign({}, data, {
      status: data.status,
    });
    if (data.status !== UserStatus.ACTIVE || !data.lastLogin) {
      dataToSend.username = data.email;
    }
    delete dataToSend?.location;
    delete dataToSend?.deactivatedReasonLc;
    delete dataToSend?.relationLc;
    delete dataToSend?.role;
    return dataToSend;
  }

  decrypt(
    encryptedData: string,
    IV?: string,
    algoType?: string,
    secret?: string,
  ) {
    try {
      if (!encryptedData) return {};
  
      const key = CryptoJS.enc.Utf8.parse(secret || '');
      const iv = CryptoJS.enc.Utf8.parse(IV || '');
  
      let decrypted: string;
  
      switch (algoType) {
        case 'AES-256-CBC':
          decrypted = CryptoJS.AES.decrypt(
            encryptedData,
            key,
            { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
          ).toString(CryptoJS.enc.Utf8);
          break;
  
        default:
          console.warn('Unsupported algorithm, returning empty object');
          return {};
      }
  
      return JSON.parse(decrypted || '{}');
    } catch (error) {
      console.error('Decryption error in CurrentUserAdapter:', error);
      return {};
    }
  }
  
}
